import JoinPage from './views/JoinPage'

export default JoinPage
